import gql from 'graphql-tag';

export default gql`
  fragment blastengineMailCampaignMailBounceActivityFragment on BlastengineMailCampaignMailBounceActivity {
    id
    mailCampaignSend {
      id
      createdAt
      mailCampaign {
        id
        uuid
        title
        subject
        fromAddress
        fromName
        cc
        bcc
        sendAt
        isImmediately
        bodyHtml
        pool {
          uuid
        }
      }
    }
  }
`;
